import { Component, input } from '@angular/core';
import { MaterialModule } from '../../common/material/material.module';
import { DatePipe } from '@angular/common';
import { NetzzuordnungenImportSnapshot } from '../../domain/model/netzzuordnungen-import-snapshot.model';
import { NetzverknuepfungenListComponent } from './netzverknuepfungen-list/netzverknuepfungen-list.component';
import { NetzzuordnungImportReportComponent } from './netzzuordnung-import-report/netzzuordnung-import-report.component';

@Component({
    selector: 'redispatch-dashboard-netzzuordnungen-import',
    imports: [
        MaterialModule,
        DatePipe,
        NetzverknuepfungenListComponent,
        NetzzuordnungImportReportComponent,
    ],
    templateUrl: './dashboard-netzzuordnungen-import.component.html',
    styleUrl: './dashboard-netzzuordnungen-import.component.scss',
})
export class DashboardNetzzuordnungenImportComponent {

    netzzuordungImport = input<NetzzuordnungenImportSnapshot>();

    tooltipText = 'Diese Liste bezieht sich immer auf den zuletzt gelaufenen und gültigen Import der Netzzuordnungen.';
}
